export default __webpack_public_path__ + "static/media/promocionAlarma3Mobile.63f1a36a.png";